<h1 mat-dialog-title>{{ title }}</h1>
<mat-dialog-content id="dataToPrint">
  <div class="col-12" style="margin-bottom: 30px; page-break-after: always;">
    <div class="row" style="margin-bottom: 10px;">
      <div class="col-12" style="font-family: sans-serif; font-size: 0.6rem;">
        <qrcode #qrdata [qrdata]="data.qrCode" [width]="150" [errorCorrectionLevel]="'H'" [elementType]="'url'"></qrcode>
      </div>
    </div>
    <div class="row">
      <div class="col-12" style="clear: both; text-align: left;">
        <!-- Company data -->
        <div class="row">
          <div class="col-12" style="font-family: sans-serif; font-size: 0.6rem;">
            <div style="margin-bottom: 0.7rem; font-size: 0.7rem;">
              <strong>{{ subtitle }}</strong>
            </div>
            <div style="clear: both; display: flex;">
              <div style="float: left; width: 200px; margin-right: 8px;">
                <strong>{{ 'companies.dialog.printVideoQrCode.company' | translate }}</strong>
              </div>
              <div style="float: left; width: 300px">{{ data.name }}</div>
            </div>
            <div style="clear: both; display: flex;" *ngIf="propertyName !== ''">
              <div style="float: left; width: 200px; margin-right: 8px;">
                <strong>{{ 'companies.dialog.printVideoQrCode.propertyName' | translate }}</strong>
              </div>
              <div style="float: left; width: 300px">{{ propertyName }}</div>
            </div>
            <div style="clear: both; display: flex;">
              <div style="float: left; width: 200px; margin-right: 8px;">
                <strong>{{ 'companies.dialog.printVideoQrCode.address' | translate }}</strong>
              </div>
              <div style="float: left; width: 300px">{{ data.address }}</div>
            </div>
            <div style="clear: both; display: flex;">
              <div style="float: left; width: 200px; margin-right: 8px;">
                <strong>{{ 'companies.dialog.printVideoQrCode.city' | translate }}</strong>
              </div>
              <div style="float: left; width: 300px">{{ data.city }}</div>
            </div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-12" style="width: 100%; font-family: sans-serif; font-size: 0.6rem;">
            <div style="margin-top: 30px; text-align-last: center;">
              <img src="https://wa.archedi.it/assets/img/logo/logo.png" alt="{{ configService.ownerNicename }}"
                height="20">
              <div style="margin-top: 5px;">
                &copy; Archedi {{ year }}, tutti i diritti riservati
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<div mat-dialog-actions>
  <div class="row w-100 mt-5">
    <div class="col-12 col-md-3 text-left">
      <a mat-button (click)="onClose()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.close' | translate }}</a>
    </div> <!-- /.col -->
    <div class="col-12 col-md-3 text-left" *ngIf="data.qrCode !== ''" >
      <a mat-button (click)="onSaveQRAsImage(qrdata)" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.download' | translate }}</a>
    </div>
    <div class="col-12 col-md-6 text-right">
      <a mat-button (click)="onPrint()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.print' | translate }}</a>
    </div> <!-- /.col -->
  </div> <!-- /.row -->
</div>